import { ScopeOption } from '../types';

/**
 * Варианты скоупов для модуля «Журнал действий» (audit.*)
 */
export const auditScopes: Record<string, ScopeOption[]> = {
  // Навигация
  'audit.menu': [
    { value: 'true', label: 'Включено', description: 'Отображать пункт «Журнал действий» в боковом меню', badgeColor: '#10b981' },
    { value: 'none', label: 'Выключено', description: 'Пункт скрыт из бокового меню', badgeColor: '#ef4444' }
  ],

  // Просмотр журнала: зона видимости записей
  'audit.view': [
    { value: 'all', label: 'Вся сеть', description: 'Все записи журнала без ограничений', badgeColor: '#10b981' },
    { value: 'own_region', label: 'Свой регион', description: 'Действия по аптекам своего города (cityId)', badgeColor: '#06b6d4' },
    { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: 'Действия по закрепленным точкам (myPharmacy)', badgeColor: '#3b82f6' },
    { value: 'below_my_role', label: 'Ниже моей роли', description: 'Действия сотрудников строго младшего ранга', badgeColor: '#f59e0b' },
    { value: 'created_by_me', label: 'Созданные мной', description: 'Только собственные действия', badgeColor: '#8b5cf6' },
    { value: 'none', label: 'Запрещено', description: 'Журнал действий недоступен', badgeColor: '#ef4444' }
  ],

  'audit.details.view': [
    { value: 'true', label: 'Разрешено', description: 'Показывать «было → стало», снимки удаленных данных и параметры операции', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'В карточке записи только общие сведения', badgeColor: '#ef4444' }
  ],

  'audit.export': [
    { value: 'true', label: 'Разрешено', description: 'Выгрузка записей по текущим фильтрам в CSV', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Выгрузка журнала заблокирована', badgeColor: '#ef4444' }
  ],

  'audit.cleanup': [
    { value: 'true', label: 'Разрешено', description: 'Удаление записей старше срока хранения (2 года)', badgeColor: '#10b981' },
    { value: 'none', label: 'Запрещено', description: 'Очистка журнала заблокирована', badgeColor: '#ef4444' }
  ]
};
